import React from 'react';
import RequirementForm from '@/components/DynamicForm/RequirementForm';
import { TCustomField, TEntryForm, TRequirementFieldConfig } from '@/components/DynamicForm/model';
import type { DragEndEvent } from '@dnd-kit/core/dist/types';

const disabledFields = ['type'];

export default function DisplayForm({
  campId,
  onSortEnd,
  onFieldSelect,
  selectedFieldId,
  requirement,
  customFieldList,
  fields,
}: {
  campId: string;
  onSortEnd?(event: DragEndEvent): void;
  onFieldSelect: (fieldId: string) => void;
  selectedFieldId: string;
  requirement: TEntryForm;
  customFieldList: TCustomField[];
  fields: TRequirementFieldConfig[];
}) {
  return (
    <div className="config-display-form-wrapper">
      <div className="config-display-form-header">
        配置效果
        <span>会自动收集用户账号绑定的手机号，无需让客户手动填写</span>
      </div>
      <div className="config-display-form-body">
        <RequirementForm
          campId={campId}
          displayMode
          forceUpdate
          requirement={requirement}
          onFieldSelect={onFieldSelect}
          disabledFields={disabledFields}
          selectedItem={selectedFieldId}
          onSortEnd={onSortEnd}
          customFieldList={customFieldList}
          fields={fields}
        />
      </div>
    </div>
  );
}
